import { useNavigate } from "react-router-dom";

import { Module } from "types/generated";

const LATEST_KEY = "latest";

type VersionResolver = {
  term: string;
};

const useModuleVersionResolver = (versionParam: string, module: Module): VersionResolver => {
  const navigate = useNavigate();

  if (versionParam === LATEST_KEY) {
    const latestVersionId = module?.latest?.id;
    if (latestVersionId) {
      return { term: latestVersionId };
    } else {
      navigate(`/module/${module.id}`, { replace: true });
      return { term: versionParam };
    }
  }

  return { term: versionParam };
};

export default useModuleVersionResolver;
